import { ICyberSourceAuthRequest, ICyberSourceMicroformContext, ICyberSourceVerificationRequest } from "../../types/Payment";

import { CyberSourceSAResponse } from "JS/types/CyberSource";
import { IBaseHttpService } from "../../types/Http";
const BASE_URL = '/cs/flex';

export interface ICyberSourceMicroformsService {
	getMicroformContext(): Promise<ICyberSourceMicroformContext>
	createCardWithToken(authRequest: ICyberSourceAuthRequest): Promise<boolean>
	verifySavedCard(request: ICyberSourceVerificationRequest): Promise<CyberSourceSAResponse>
}

export default class CyberSourceMicroformsService implements ICyberSourceMicroformsService {
	constructor(
		private _httpService: IBaseHttpService
	) { }

	getMicroformContext(): Promise<ICyberSourceMicroformContext> {
		return this._httpService.get<ICyberSourceMicroformContext>(`${BASE_URL}/get-context/`);
	}

	createCardWithToken(authRequest: ICyberSourceAuthRequest): Promise<boolean> {
		return this._httpService.post<boolean>(`${BASE_URL}/tokenize/`, authRequest);
	}

	verifySavedCard(request: ICyberSourceVerificationRequest): Promise<CyberSourceSAResponse> {
		return this._httpService.post<CyberSourceSAResponse>(`${BASE_URL}/verify/`, request);
	}
}